import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import CarouselImage from "./CarouselImage";

function ControlledCarousel() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel activeIndex={index} onSelect={handleSelect} className="carousel-container">
      {[
        {
          img: "https://66fed9cbf77d7bf7bb163e56--harmonious-dieffenbachia-13d310.netlify.app/static/media/Image-1.9bd137f0ace18b5d06d0.jpeg",
          title: "DataValley.ai",
          text: "Heartfelt gratitude for recognizing my efforts and awarding me the Best Performer at DATAVALLEY.AI."
        },
        {
          img: "https://66fed9cbf77d7bf7bb163e56--harmonious-dieffenbachia-13d310.netlify.app/static/media/Image-2.fbbc3c63b94cc20ed2a2.jpeg",
          title: "With Friends",
          text: "Friendship improves happiness, and abates misery, by doubling our joys, and dividing our grief."
        },
        {
          img: "https://66fed9cbf77d7bf7bb163e56--harmonious-dieffenbachia-13d310.netlify.app/static/media/Image-3.2dc40bf6d15b67663604.jpeg",
          title: "Graduation Day",
          text: "The direction in which education starts a man will determine his future."
        },
        {
          img: "https://66fed9cbf77d7bf7bb163e56--harmonious-dieffenbachia-13d310.netlify.app/static/media/Image-4.084411e7367c8e84c8a8.jpeg",
          title: "Day End With Friends",
          text: "Campus is the best place to enjoy life happily; nothing else can beat that; enjoy it, friends."
        }
      ].map((item, idx) => (
        <Carousel.Item key={idx}>
          <CarouselImage text={item.img} />
          <Carousel.Caption>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default ControlledCarousel;
